import { localDateOnly } from '../../utils/localDate';
import { bookOptions } from '../../utils/reportFormat';
import './reports.css';

/** Date range, testament and book. The reader and year live in the context row. */
const ReportFilters = ({ filters, onChange }) => (
  <div className="report-filters">
    <div className="report-filter-pair">
      <div className="report-field">
        <label htmlFor="report-from">From</label>
        <input
          type="date"
          id="report-from"
          value={filters.startDate}
          max={filters.endDate || localDateOnly()}
          onChange={(e) => onChange({ startDate: e.target.value })}
        />
      </div>
      <div className="report-field">
        <label htmlFor="report-to">To</label>
        <input
          type="date"
          id="report-to"
          value={filters.endDate}
          min={filters.startDate || undefined}
          max={localDateOnly()}
          onChange={(e) => onChange({ endDate: e.target.value })}
        />
      </div>
    </div>

    <div className="report-filter-pair">
      <div className="report-field">
        <label htmlFor="report-testament">Testament</label>
        <select
          id="report-testament"
          value={filters.testament}
          onChange={(e) => {
            const testament = e.target.value;
            // A book the testament excludes can't stay selected.
            const keepBook = !filters.book || bookOptions(testament).includes(filters.book);
            onChange({ testament, ...(keepBook ? {} : { book: '' }) });
          }}
        >
          <option value="">All</option>
          <option value="Old">Old Testament</option>
          <option value="New">New Testament</option>
        </select>
      </div>
      <div className="report-field">
        <label htmlFor="report-book">Book</label>
        <select
          id="report-book"
          value={filters.book}
          onChange={(e) => onChange({ book: e.target.value })}
        >
          <option value="">All books</option>
          {bookOptions(filters.testament).map((book) => (
            <option key={book} value={book}>{book}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
);

export default ReportFilters;
